import React, {lazy, useMemo} from 'react';
import {Switch, Route} from 'react-router-dom';
import BigNumber from "bignumber.js";
import Header from '../Header';
import Footer from '../Footer';
import DepositCardWrapperComp from "../DepositCardWrapperComp";
import {useFarmFromPid} from "../../state/hooks";
import {BIG_ZERO, getBalanceNumber} from "../../utils/formatBalance";

// const IndexPage = lazy(() => import('../../routes/IndexPage'));
const AnalyticsPage = lazy(() => import('../../routes/AnalyticsPage'));
const RobotsPage = lazy(() => import('../../routes/RobotsPage'));
const PortfolioPage = lazy(() => import('../../routes/PortfolioPage'));

const Layout = ({analyticsList, userPoolsData, userHistory, setUserPoolsData, predictedPools}) => {

    const isUserDataExist = userPoolsData && userPoolsData.robotsInfo && userPoolsData.robotsInfo.length > 0;

    const agrRobotData = useMemo(() => {
        return userPoolsData && userPoolsData.robotsInfo.filter(item => item.robotType === "AGGRESSIVE")[0];
    }, [userPoolsData]);
    const consRobotData = useMemo(() => {
        return userPoolsData && userPoolsData.robotsInfo.filter(item => item.robotType === "CONSERVATIVE")[0];
    }, [userPoolsData]);
    const customRobotsData = useMemo(() => {
        return userPoolsData && userPoolsData.robotsInfo.filter(item => item.robotType === "CUSTOM");
    }, [userPoolsData]);

    const totalRobotsDeposit = useMemo(() => {
        return isUserDataExist && userPoolsData.robotsInfo.reduce((partialSum, a) => partialSum + a.lpAmountStakedInBusd + a.lpBalanceInBusd, 0) || 0;
    }, [userPoolsData, isUserDataExist]);
    const totalRobotsPending = useMemo(() => {
        return isUserDataExist && userPoolsData.robotsInfo.reduce((partialSum, a) =>
            partialSum + (a.immutableRobotState === "WAITING_SUITABLE_APR" ? a.entrySettings && a.entrySettings.busdAmount && a.entrySettings.busdAmount : 0), 0) || 0;
    }, [userPoolsData, isUserDataExist]);

    const state = useFarmFromPid(0);
    const busdDeposit = state && state.userData && state.userData.userDeposit && new BigNumber(state.userData.userDeposit) || BIG_ZERO;
    const availableDeposit = getBalanceNumber(busdDeposit) - totalRobotsPending;

    const activePoolsId = userPoolsData.robotsInfo.map(item => item.poolIndex);
    const uniquePools = activePoolsId && analyticsList.filter(item => !activePoolsId.includes(item.poolIndex));


    return (
        <div>
            <Header/>
            <DepositCardWrapperComp totalRobotsDeposit={totalRobotsDeposit} availableDeposit={availableDeposit}/>
            <Switch>
                <Route path="/" exact><AnalyticsPage
                    poolsData={userPoolsData.robotsInfo}
                    customRobotsData={customRobotsData}
                    setUserPoolsData={setUserPoolsData}
                    uniquePools={uniquePools}
                    analyticsList={analyticsList}
                    availableDeposit={availableDeposit}/></Route>
                <Route path="/analytics" exact>
                    <AnalyticsPage
                        poolsData={userPoolsData.robotsInfo}
                        customRobotsData={customRobotsData}
                        setUserPoolsData={setUserPoolsData}
                        uniquePools={uniquePools}
                        analyticsList={analyticsList}
                        availableDeposit={availableDeposit}/>
                </Route>
                <Route path="/robofarm" exact><RobotsPage
                    agrRobotData={agrRobotData}
                    customRobotsData={customRobotsData}
                    consRobotData={consRobotData}
                    analyticsList={analyticsList}
                    setUserPoolsData={setUserPoolsData}
                    uniquePools={uniquePools}
                    availableDeposit={availableDeposit}
                    predictedPools={predictedPools.predictableRobots}
                /></Route>
                <Route path="/portfolio" exact><PortfolioPage
                    poolsData={userPoolsData.robotsInfo}
                    robotHistories={userHistory.robotHistories}
                    totalRobotsDeposit={totalRobotsDeposit}
                    analyticsList={analyticsList}/></Route>
            </Switch>
            <Footer/>
        </div>
    );
};

export default Layout;

